import { createContext, useState } from "react";
export const BASE_URL = "https://api.codewithaniket.online/api/v1";
// export const BASE_URL = "http://localhost:4000/api/v1";
export const PROFILE__URL = "https://api.codewithaniket.online";
export const getPlainText = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const UserContext = createContext();

const UserContextProvier = ({children}) => {
  const [currentUser, setCurrentUser] = useState();
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(currentUser ? true : false);
  // useEffect(() => {
  //   localStorage.setItem("user", JSON.stringify(currentUser));
  // }, [currentUser]);

  return <UserContext.Provider value={{error, setError, message, setMessage, isAuthenticated, setIsAuthenticated, currentUser, setCurrentUser}}>
    {children}
  </UserContext.Provider>
};


export default UserContextProvier;
